<div class="fix-action-dialog">
	<h1 mat-dialog-title>Layout</h1>
	<mat-dialog-content fxLayout="column">
		<mat-card>
			<mat-card-content>
				<mat-form-field class="input-text">
					<mat-label>Layout Name...</mat-label>
					<input #layoutname="ngModel" [(ngModel)]="data.name" autocomplete="off" matInput maxlength="255" minlength="3" name="layoutname" placeholder="layoutname" required type="text">
					<mat-error *ngIf="layoutname.errors?.['required'];"><span translate>入力してください</span></mat-error>
					<mat-error *ngIf="layoutname.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
					<mat-error *ngIf="layoutname.errors?.['minlength']"><span translate>短すぎます</span></mat-error>
				</mat-form-field>
			</mat-card-content>
		</mat-card>

	</mat-dialog-content>
	<div class="spacer"></div>
	<mat-dialog-actions fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-around" style="margin:20px 0;">
		<button (click)="cancel()" color="warn" mat-dialog-close="" mat-stroked-button id="mat-cancel-button"><span translate>キャンセル</span></button>
		<button (click)="onAccept()" [disabled]="isProgress" cdkFocusInitial color="primary" mat-raised-button id="mat-ok-button"><span translate>OK</span></button>
	</mat-dialog-actions>
</div>
